
function sortMenu(data){
    data.sort(function(a,b){return a.permissionOrder - b.permissionOrder});
    for(var i = 0;i < data.length;i++){
      var obj = data[i];
      if(obj.items.length > 1){
         obj.items.sort(function(a,b){return a.permissionOrder - b.permissionOrder});
      }
    }
    return data;
}

export default{
  sortMenu
}
